const en = {
  common: {
    cancel: "Cancel",
    close: "Close",
    done: "Done",
    refresh: "Refresh",
    select: "Select",
    clear: "Clear",
    submit: "Submit",
    setDate: "Set Date",
    loading: "LOADING ....",
    feedback: "Feedback",
    genericError: "There is something wrong!",
    yes: "Yes",
    no: "No",
    saveChanges: "Save changes",
    noDataFound: "No Data Found!",
    learnMore: "Learn More",
  },
  navigation: {
    home: "Home",
    packageDeals: "Package Deals",
    flightSchedules: "Flight Schedules",
    aboutUs: "About Us",
    contactUs: "Contact Us",
    faq: "FAQ",
    jobs: "Jobs",
    entryFee: "Entry Fee",
    myAccount: "My account",
    logIn: "Log In",
    signUp: "Sign up",
    logOut: "Log Out",
    chooseCountry: "Choose a Country",
  },
  auth: {
    loginTitle: "Log in to Satyam Holidays",
    loginSubtitle: "Welcome back. Sign in to book and manage your trips.",
    password: "Password",
    enterEmail: "Email address",
    enterPassword: "Password",
    forgotPasswordQuestion: "Forgot password?",
    forgotPassword: "Forgot password",
    forgotPasswordSubtitle:
      "Enter your email and we will send reset instructions.",
    forgotPasswordInstructions:
      "Please check your inbox for instructions on how to change your password. If you don't see it there, remember to also check your spam folder",
    submitEmail: "Send reset link",
    noAccount: "Don't have an account?",
    createAccount: "Create your account",
    registerSubtitle:
      "Join Satyam Holidays to book faster and keep all your trips in one place.",
    enterFirstName: "Enter your first name",
    enterLastName: "Enter your last name",
    enterPhoneNumber: "Enter your Phone Number",
    heardFrom: "Heard From",
    heardAboutUs: "How did you heard about us?",
    referralFriend: "Referral from a Friend",
    tvRadioAd: "TV or Radio Ad",
    newspaperMagazine: "Newspaper or Magazine",
    flyerBrochure: "Flyer or Brochure",
    other: "Other",
    otherFieldRequired: "This field is required when Heard From is Other",
    thisField: "This field",
    pleaseSpecify: "Please Specify:",
    agreeTo: "I agree to the",
    privacyPolicy: "Privacy Policy.",
    alreadyHaveAccount: "Already Have an account?",
    verifyCode: "Verify Code",
    noEmail: "Have not recieved any email?",
    resend: "Resend",
    missingToken: "Missing authentication token",
    verifyError: "An error occurred while verifying the code.",
  },
  languageModal: {
    title: "Language and currency",
    description: "Choose your preferred language and currency",
    language: "Language",
    currency: "Currency",
    save: "Save & continue",
  },
  languages: {
    english: "English",
    dutch: "Dutch",
  },
  footer: {
    reservations: "Reservations",
    onlineTool: "Use our online tool",
    becomeMember: "Become a member",
    registerPoints: "Register now to earn points",
    contactUs: "Contact us",
    callSuriname: "Call us on 1611 in Suriname",
    callEurope: "Call us on +31-070-7113625 in Europe",
    version: "Version {{version}}",
    poweredBy: "Powered by",
    poweredByAria: "Powered by DivyAI LLC. Visit divyai.com",
    inPartnership: "Powered by",
    inPartnershipAria:
      "Satyam Holidays in partnership with DivyAI LLC. Visit divyai.com",
    tagline: "Flights, package deals and travel support from Satyam Holidays.",
    explore: "Explore",
    privacy: "Privacy policy",
    copyright: "© {{year}} Satyam Holidays. All rights reserved.",
  },
  whatsNew: {
    title: "New version available",
    version: "Version {{version}}",
    languageTitle: "Choose your language",
    cta: "Got it",
  },
  changelog: {
    view: "View changelog",
    title: "Changelog",
    description: "See what changed in each version.",
    eyebrow: "Product updates",
    latest: "Latest",
    current: "You are on version {{version}}",
    changeCount: "{{count}} updates",
  },
  contact: {
    title: "Contact Us",
    eyebrow: "Contact",
    heading: "Let's start a conversation",
    subtitle:
      "Whether you're planning your next adventure or have questions about an existing booking, our team is here to help. Reach out and we'll get back to you as soon as we can.",
    ourBranches: "Our Branches",
    getInTouch: "Get in touch",
    yourName: "Your Name",
    yourEmail: "Your Email",
    yourMessage: "Your Message",
    quickContact: {
      callLabel: "Call us on",
      callOr: "or",
      callValue: "1611 or +597 436950",
      emailLabel: "Email us",
      emailValue: "satyam@satyamholidays.net",
      whatsappLabel: "WhatsApp",
      whatsappValue: "Pick your office",
      callAction: "Call now",
      emailAction: "Send email",
      whatsappAction: "Start chat",
    },
    whatsappPicker: {
      title: "Chat on WhatsApp",
      subtitle:
        "Pick the office closest to you and we'll continue the conversation directly in WhatsApp.",
      redirectNotice: "You'll be redirected to WhatsApp.",
    },
    branches: {
      eyebrow: "Our locations",
      title: "Visit our offices",
      subtitle: "Eight offices across four countries, ready to welcome you.",
      headOffice: "Head Office",
      branchOffice: "Branch Office",
      countries: {
        suriname: "Suriname",
        netherlands: "Netherlands",
        india: "India",
        curacao: "Curaçao",
      },
      fields: {
        address: "Address",
        phone: "Phone",
        whatsapp: "WhatsApp",
        hours: "Opening hours",
      },
      chatButton: "Chat on WhatsApp",
      comingSoon: "Coming soon",
      officesMeta: "{{offices}} offices · {{countries}} countries",
    },
    form: {
      eyebrow: "Send us a message",
      title: "Get in touch",
      subtitle:
        "Fill out the form and a team member will get back to you within 24 hours.",
      name: "Full name",
      namePlaceholder: "Jane Doe",
      email: "Email address",
      emailPlaceholder: "you@example.com",
      subject: "Subject",
      subjectPlaceholder: "How can we help?",
      message: "Message",
      messagePlaceholder: "Tell us a bit about your inquiry...",
      submit: "Send message",
      sending: "Sending...",
      successTitle: "Message sent",
      successMessage:
        "Thank you for reaching out. We'll be in touch with you soon.",
      sendAnother: "Send another message",
    },
    visitUs: {
      eyebrow: "Visit us",
      title: "Our head office",
      address: "Doebestraat # 3, P.O. Box 5145, Kwatta, Paramaribo, Suriname",
      hours: "Mon – Fri  08:30 – 16:30",
      directions: "Get directions",
    },
  },
  account: {
    tabs: {
      myAccount: "My Account",
      myActivities: "My Activities",
      tikkie: "Tikkie",
      stripe: "Stripe",
      passportManager: "Passport Manager",
      pnrManager: "PNR Manager",
      reports: "Reports",
    },
    sessionExpired: "The session has expired, please relogin!",
    eyebrow: "Your profile",
    profileHint: "Keep your details up to date, exactly as they appear on your passport.",
    personalDetails: "Personal details",
    contactDetails: "Contact details",
    security: "Security",
    memberId: "Member ID",
    memberSince: "Member Since",
    availablePoints: "Available points",
    currentStatus: "Current Status",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    dateOfBirth: "Date of birth",
    phoneNumber: "Phone number",
    enterPhoneNumber: "Enter phone number",
    passportNumber: "Passport number",
    month: "Month",
    monthRequired: "Month Field is required",
    dateOfBirthInvalid: "Date of birth is invalid",
    months: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December",
    },
    changePasswordQuestion: "Change Password ?",
    saveChanges: "Save changes",
    updateSuccess: "Your account updated successfully!",
    oldPassword: "Old Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    passwordsMustMatch: "Passwords must match",
    enterOldPassword: "Enter your old Password",
    enterNewPassword: "Enter your new Password",
    enterConfirmPassword: "Enter your confirm Password",
    changePassword: "Change Password",
    passwordChanged: "Password has changed successfully",
  },
  search: {
    airlineCarriers: "Airline Carriers",
    airport: "Airport",
    airportSearchHint: "Type at least 2 characters to search airports",
    airportNoResults: "No airports found",
    exampleLocation: "Example 'Amsterdam'",
    recentAirports: "Recent searches",
    filterActive: "{{count}} filter active",
    clearFilter: "Clear Filter",
    pricingTable: "Pricing table",
    pricingTableTitle: "Pricing Table",
    pricingTableHint: "Compare fares across nearby dates",
    pricingCheaper: "Cheaper",
    pricingHigher: "Higher",
    pricingTip: "Tip",
    pricingDisclaimer:
      "Click a date in the table and our search engine will try to find you a better price.",
    cheaperPriceToastTitle: "Congratulations!",
    cheaperPriceToast: "Our search engine found a cheaper price for you.",
    departure: "Departure ",
    return: "Return ",
    noFlights: "No flights found for these dates",
    noFlightsHint:
      "Try another date in the pricing table, or search with a stopover in the filters to see more options.",
    noFlightsTipDate: "Pick another date",
    noFlightsTipStop: "Allow a stopover",
    noFlightsTipFilters: "Relax your filters",
    packageDealTitle: "Package deal booking",
    packageDealDescription:
      "You are searching for flights for a package tour. The package price ({{price}}) will be added to your flight price for the total amount.",
    checkingAvailability:
      "Hang tight while we check whether this flight is still available!",
    unavailable: "This flight is not available now!",
    modifySearch: "Modify search",
    closeSearch: "Close",
    traveler: "{{count}} traveler",
    travelers: "{{count}} travelers",
  },
  faq: {
    eyebrow: "Help",
    title: "Frequently asked questions",
    description:
      "Clear answers on flights, visas, baggage and bookings. Search a topic or browse the list.",
    searchPlaceholder: "Search questions",
    browseTopics: "Topics",
    questionsCount: "{{count}} questions",
    questionCountOne: "1 question",
    resultsCount: "{{count}} matching questions",
    emptyTitle: "No matching questions",
    emptyDescription: "Try another search, or choose a topic from the list.",
    ctaEyebrow: "Support",
    ctaTitle: "Still looking for an answer?",
    ctaDescription:
      "If your question is not listed here, our team can help with your booking, visa or travel plans.",
    ctaAction: "Contact us",
  },
  aboutUs: {
    heroEyebrow: "Since 2006",
    heroTitle: "The people behind Satyam",
    heroSubtitle:
      "A Surinamese travel company connecting Europe, the Caribbean, North America and the world, with care, craft and a personal touch.",
    storyEyebrow: "Our journey",
    storyTitle: "From one idea to a travel house",
    tabs: {
      about: "About",
      features: "Features",
      team: "Team",
      companyInfo: "Company Info",
    },
    vision: {
      title: "Vision",
      description:
        "In 2028, SH is physically accessible in 7 countries and is known worldwide as a prominent innovative and technology-driven travel agency of Surinamese origin.",
    },
    mission: {
      title: "Mission",
      description:
        "Proudly endorse Suriname's travel expertise by helping global travelers realize their adventurous travel dreams through high-quality innovation.",
    },
    features: {
      passportScanner: {
        title: "Passport scanner",
        description:
          "With our passport scanner feature, you can quickly and easily scan your passport right from your phone or computer. This means no more fumbling with paper documents at the travel agency. Our passport scanner feature allows you to breeze through the reservation process and get on your way to your destination in no time.",
        cta: "Ready to try it out? Let's get started!",
      },
      virtualReality: {
        title: "Virtual reality feature",
        description:
          "Exciting news! We're currently working on a virtual reality feature for our web application tool for flights that will take your travel experience to the next level. With virtual reality, you'll be able to explore your destination like never before, right from the comfort of your own home. Imagine being able to walk through the streets of Paris, sit on the beaches of Hawaii, or even climb Mount Everest - all without ever leaving your living room. Our virtual reality feature will provide a fully immersive travel experience, allowing you to see, hear, and feel like you're actually there.",
        note: "While we're still in development, we can't wait to share this new feature with you in the near future. Stay tuned for updates and get ready to take off on the ultimate virtual travel adventure!",
      },
    },
    team: {
      eyebrow: "Meet the team",
      departments: {
        executiveBoard: "Management",
      },
      members: {
        anielB: {
          title: "Founder & Chief Executive Officer",
          biography:
            "Aniel B. is the Founder and current CEO of Satyam Holidays. His responsibility is to ensure the company remains at the forefront of the travel industry while maintaining the highest standards of ethics and compliance. As CEO, he guides the company to success by making strategic decisions, managing operations and resources, and acting as the primary point of communication between the board and company stakeholders.",
        },
        shivaniB: {
          title: "Chief Marketing Officer",
          biography:
            "Shivani B. is the Chief Marketing Officer. She develops and implements marketing strategies to increase brand awareness and sales while ensuring the company's marketing efforts are aligned with its overall business objectives.",
        },
        shivaB: {
          title: "Chief Technology Officer",
          biography:
            "Shiva B. is responsible for recording, analyzing, and interpreting test data, proposing modifications and retesting products, qualifying the final product or system, servicing and maintaining equipment, preparing product documentation, writing reports, giving presentations, and monitoring products in use to improve future designs.",
        },
        rishiS: {
          title: "Chief Finance Officer",
          biography:
            "Rishi S. is the Chief Finance Officer and is responsible for managing the company's financial actions, including tracking cash flow and financial planning, analyzing financial strengths and weaknesses, and proposing corrective actions.",
        },
        afiekB: {
          title: "Operation Manager",
          biography:
            "Afiek B. is the Operation Manager and is responsible for overseeing the company's ongoing operations and procedures, ensuring operational excellence and efficiency across all departments.",
        },
        corettaC: {
          title: "Quality Manager",
          biography:
            "Coretta C. is the Quality Manager and is responsible for ensuring that the company's products and services meet established quality standards, including reliability, usability, and performance.",
        },
        warshaB: {
          title: "Finance Manager",
          biography:
            "Warsha B. is the Finance Manager and is responsible for managing the company's financial health by overseeing budgeting, forecasting, and financial reporting, as well as ensuring compliance with financial regulations.",
        },
        augustI: {
          title: "Advisor",
          biography:
            "August I. is an Advisor. His role is to provide strategic guidance and expert advice to the company's leadership team, helping shape business strategies and drive growth.",
        },
        justM: {
          title: "Forever in Our Hearts",
          biography:
            "Just's leadership was never about titles, it was about care, integrity, and vision. He inspired us to dream bigger while staying grounded in humility and humanity. His legacy continues to live through the work he loved and the people he touched. He was a guiding light, a listener, and a friend to everyone around him. His humility, kindness, and quiet strength shaped not only our vision but also the spirit of our team. Though he is no longer with us, his values continue to guide every step we take.",
        },
      },
    },
    readBio: "Read Bio",
    inMemoriam: {
      eyebrow: "Honoring their memory",
      title: "In Loving Memory",
      subtitle:
        "We honor the colleagues whose vision, warmth, and unwavering dedication left a lasting impact. Their legacy inspires us every day and serves as the foundation for our future.",
      badge: "In Memoriam",
      readLegacy: "Read their legacy",
    },
    companyStory:
      "Aniel was tired of struggling to book affordable flights for his vacations. But instead of giving up, he had an idea that could change the world. He developed his own flight search engine, and thus began an exciting journey that would revolutionize the way people search for flights. He created a platform that not only finds the cheapest flights but also offers a seamless booking experience for travelers worldwide. From a simple idea to a global solution, his passion and hard work has made booking flights more accessible and affordable for everyone.",
    discoverMore: "Discover More",
    questionDescription:
      "With lightning-fast caching and easy-to-implement APIs, distributing our content is a breeze. We offer custom solutions for any market",
    questions: {
      virtualInterlining: "What is Virtual Interlining?",
      airline: "I am an airline",
      airport: "I am an airport",
      carrier: "I am a ground or sea carrier",
      retailer: "I am a travel retailer",
      affiliate: "I want to be an affiliate",
      provider: "I am a travel service provider",
    },
    history: {
      october2007: {
        date: "October 2007",
        description:
          "In October 2007, Aniel begins his journey in the travel industry with a vision to create a company that revolutionizes the way people travel. He launches Satyam Tours and sets out on his mission.",
      },
      december2007: {
        date: "December 2007",
        description:
          "Satyam Tours becomes IATA certified, a significant milestone in the company's growth and credibility.",
      },
      april2010: {
        date: "April 2010",
        description:
          "Satyam Tours expands its global reach by opening a branch office in the Netherlands, solidifying its position as a leading player in the travel industry.",
      },
      may2011: {
        date: "May 2011",
        description:
          "Satyam Tours opens a branch office in India, which becomes an instant success. Aniel's innovative ideas and commitment to customer satisfaction win over the hearts of travelers, and Satyam Tours becomes a household name in the Indian travel industry.",
      },
      august2013: {
        date: "August 2013",
        description:
          "Satyam Tours continues its expansion by opening four more branches in Suriname, further cementing its reputation as a major player in the travel industry.",
      },
      december2021: {
        date: "December 2021",
        description:
          "Aniel takes Satyam Tours to the next level by opening a brand new branch in Curacao, expanding the company's reach and bringing its innovative services to a new market.",
      },
      october2022: {
        date: "October 2022",
        description:
          "Satyam Tours receives ANVR, SGR, and Calamiteitenfonds certifications, a recognition of the company's commitment to quality and excellence.",
      },
      march2023: {
        date: "March 2023",
        description:
          "In March 2023, Satyam Tours launches its beta version, open to the public. For the first time, users can query flights and take advantage of Satyam Tours' cutting-edge artificial intelligence features directly from the company's website, further streamlining the booking process and providing an even better travel experience.",
      },
    },
  },
  entryFee: {
    hero: {
      eyebrow: "Entry fee",
      title: "Apply for your entry fee",
      subtitle:
        "A short application, a passport scan, then payment. Most requests are processed the same day.",
    },
    steps: {
      apply: "Apply",
      applyHint: "Traveler details",
      uploadPassport: "Upload Passport",
      uploadHint: "Passport scan",
      payment: "Payment",
      paymentHint: "Pay with Tikkie",
    },
    errors: {
      generic: "There is something wrong. Please try again!",
    },
    form: {
      title: "Please fill the fields to continue",
      lead: "Use the same details as on the passport. We need these to prepare the entry voucher.",
      travelSection: "Travel",
      travelerSection: "Traveler",
      continue: "Continue",
      back: "Back",
      thisField: "This field",
      dayOfArrival: "Day Of Arrival",
      ticketPurchasedFromUs: "Ticket Purchased From Us",
      isEmergency: "Is Emergency",
      gender: "Gender",
      male: "Male",
      female: "Female",
      passportNumber: "Passport number",
      scanTitle: "Scan passport",
      scanHint:
        "Upload a clear photo of the data page. We fill the traveler details for you.",
      scanAgainHint: "Scan again if you want to replace the current details.",
      scanAction: "Scan passport",
      scanAgain: "Scan again",
      fillManually: "Or fill in the traveler details yourself",
      scannedNote:
        "Details from your passport. Check them and update anything that is wrong.",
      chooseTravelerMethod:
        "Scan a passport or fill in the traveler details to continue.",
      datePlaceholder: "DD/MM/YYYY",
      openCalendar: "Open calendar",
    },
    upload: {
      title: "Upload your passport!",
      lead: "A clear colour scan or photo of the passport data page is enough. No fingers on the page.",
      readyTitle: "Passport ready",
      readyLead:
        "We already have the passport you scanned. Continue, or replace it if you want a clearer image.",
      label: "Please upload your passport.",
      submit: "Continue to payment",
    },
    payment: {
      title: "Please pay with Tikkie to finish the process",
      lead: "Your application is ready. Complete payment to receive the entry voucher.",
      newApplication: "New application?",
    },
    aside: {
      feeTitle: "Entry fee",
      feeText: "Standard processing is EUR 70 per person, paid after the application.",
      timeTitle: "Timing",
      timeText: "Apply at least one month before departure when possible. Many vouchers arrive within hours.",
      validTitle: "Validity",
      validText: "The voucher is valid for 90 days from issue. Your passport must be valid for at least six months.",
    },
  },
  jobs: {
    heroTitle: "Build your career in travel",
    heroSubtitle:
      "Join a team that connects people across Suriname, the Caribbean, and Europe. Find a role that fits how you want to grow.",
    filterJob: "Role",
    filterDepartment: "Department",
    filterLocation: "Location",
    selectJob: "All roles",
    selectDepartment: "All departments",
    selectLocation: "All locations",
    noResults: "No options available",
    search: "Search",
    reset: "Reset",
    openPositions: "Open positions",
    openPositionsHint: "Tap a role to view details and apply.",
    openRole: "{{count}} open role",
    openRoles: "{{count}} open roles",
    viewRole: "View role",
    emptyTitle: "No open vacancies right now",
    emptyMessage:
      "We do not have matching roles at the moment. Check back soon — new opportunities appear regularly.",
    backToJobs: "Back to jobs",
    roleOverview: "Role overview",
    applyHint:
      "First answer a short questionnaire, then upload your documents to complete your application.",
    uploadRequired:
      "Please upload both your resume and motivation letter before submitting.",
    applyFailed: "We could not submit your application. Please try again.",
    loginRequired: "Please log in to submit your job application.",
    errorMessage:
      "This job listing could not be loaded. Please try again later.",
    shareListing: "Share this listing",
    shareEmailBody: "I thought you might be interested in this role at Satyam:",
    applyNow: "Apply Now",
    uploadResume: "Upload your resume",
    uploadMotivation: "Upload your motivation letter",
    dropFileHint: "Drag & drop your file here, or click to browse",
    dropFileActive: "Drop your file to upload",
    removeFile: "Remove file",
    applicationSuccess:
      "Congratulations! Your job application was successfully submitted!",
    diversityNote:
      "At our company, diversity is our strength. We welcome and value everyone, regardless of gender, race, or disability, and we believe in the potential of every applicant. Join us and let's build an inclusive future together.",
    stepper: {
      questionnaire: "Questionnaire",
      documents: "Documents",
      done: "Done",
      guideline:
        "Answer each question in 75 to 100 words. Be honest and concrete. Use an example from work, school, internship, volunteering, or a personal situation where possible.",
      questionOf: "Question {{current}} of {{total}}",
      answeredCount: "{{count}}/{{total}} answered",
      answerPlaceholder: "Write your answer here...",
      wordCount: "{{count}} words · aim for {{min}}–{{max}}",
      answerRequired: "Please answer this question before continuing.",
      tooManyWords: "Please keep your answer to a maximum of {{max}} words.",
      back: "Back",
      next: "Next question",
      continueToDocuments: "Continue to documents",
      uploadTitle: "Upload your documents",
      uploadHint:
        "Add your resume and motivation letter. We store these securely with your questionnaire answers.",
      submitApplication: "Submit application",
      successHint:
        "Thanks for applying. Our recruitment team will review your answers and documents soon.",
      seeHiringProcess: "See how we hire",
    },
    questions: {
      q1: "Waarom wil je bij Satyam Holidays werken en wat denk jij in deze functie te kunnen bijdragen?",
      q2: "Beschrijf een situatie waarin je uit eigen initiatief verantwoordelijkheid nam voor een taak, probleem of resultaat. Wat deed je en wat was het resultaat?",
      q3: "Iemand wacht op informatie, een actie of een resultaat van jou, maar je hebt nog niet alles wat je nodig hebt. Hoe zorg je voor duidelijke communicatie en tijdige opvolging?",
      q4: "Beschrijf een fout of vergissing die je hebt gemaakt. Hoe ben je ermee omgegaan en wat heb je gedaan om herhaling te voorkomen?",
      q5: "Geef een voorbeeld van iets nieuws dat je moest leren, zoals een systeem, programma, proces of werkwijze. Hoe heb je dit aangepakt en hoe controleerde je of je het goed toepaste?",
      q6: "Je hebt meerdere belangrijke taken met deadlines en een collega vraagt om hulp. Hoe bepaal je wat prioriteit heeft en welke actie je onderneemt?",
    },
  },
  schedules: {
    heroEyebrow: "Live board",
    heroTitle: "Flight schedules",
    heroSubtitle:
      "Arrivals and departures for Suriname, Curaçao, and the Netherlands. Updated every four hours.",
    suriname: "Suriname",
    curacao: "Curaçao",
    netherlands: "Netherlands",
    arrivals: "Arrivals",
    departures: "Departures",
    lastUpdated: "Last updated",
    lastUpdatedHint: "This board refreshes every 4 hours.",
    flightCount: "{{count}} flights",
    flightCountOne: "1 flight",
    emptyTitle: "No {{type}} right now",
    emptyMessage:
      "Check back in a few hours. This board updates every four hours.",
    errorTitle: "We could not load the schedule",
    errorMessage: "Please try again in a moment.",
    from: "From",
    to: "To",
  },
  howWeHire: {
    intro:
      "We’re on the lookout for someone who not only has the skills but also shares our vision. We want you to be just as enthusiastic about working here as we are. To fit our culture, you should value cooperation over competition, and love a challenge. Every interview is a little different, but so are our recruiters, managers, and candidates. You won’t ruin your chances by being honest or being yourself. So what does the process look like?",
    steps: {
      cvEvaluation: {
        title: "CV evaluation",
        description:
          "First, we'll carefully evaluate your resume and cover letter to see if we might be a good fit for each other.",
      },
      videoCall: {
        title: "Video call",
        description:
          "If your experience meets the requirements, we'll schedule a video call or a regular call to find out more about each other.",
      },
      practicalTask: {
        title: "Practical task",
        description:
          "For technical roles, we've prepared various practical tasks. It can be homework or a live coding session. For customer support, we'll test your language skills via an online platform right after the video call.",
      },
      interview: {
        title: "Interview",
        description:
          "After you pass the practical task, we'll invite you for 1 or 2 rounds of interviews where you can meet your future manager and find out more about your desired role within our company.",
      },
      jobOffer: {
        title: "Job offer",
        description:
          "At this point, you’ll know a lot about the job and what to expect. It's time for the formal last step, and then we can welcome you on board.",
      },
    },
  },
  helpDesk: {
    launcher: "Help Desk",
    support: "WhatsApp Support",
    title: "Chat with our travel experts",
    description:
      "Pick the office closest to you and we'll continue the conversation right inside WhatsApp.",
    status: "Online · Usually replies within minutes",
    redirectNotice: "By starting a chat you'll be redirected to WhatsApp.",
    chat: "Chat",
    offices: {
      suriname: {
        country: "Suriname",
        location: "Paramaribo · Head Office",
      },
      netherlands: {
        country: "Netherlands",
        location: "The Hague · Europe Office",
      },
      curacao: {
        country: "Curacao",
        location: "Willemstad · Caribbean Desk",
      },
    },
  },
  reservedFlight: {
    flightDetails: "Flight Details",
    travelers: "Travelers",
    paymentInfo: "Payment Info",
    remarks: "Remarks",
    contacts: "Contacts",
    moreInfo: "More Info",
    cabin: "Cabin",
    class: "Class",
    aircraft: "Aircraft",
    carrierCode: "Carrier code",
    bookingStatus: "Booking status",
    number: "Number",
    segmentType: "Segment Type",
    numberOfStops: "Number Of stops",
    seating: "Seating",
    layoverIn: "Layover in {{airport}}",
    priceDetails: "Price details",
    nethPrice: "Neth Price",
    totalPrice: "Total Price",
    grandTotal: "Grand Total",
    generalRemarks: "General Remarks",
  },
  packageDeals: {
    title: "Package tours",
    pageSubtitle:
      "Discover our selected holiday packages. Click on an offer for the full travel programme and a reservation request.",
    loadError: "Package tours could not be loaded. Please try again later.",
    empty: "No package tours available at the moment.",
    featured: "Featured",
    from: "From",
    night: "night",
    nights: "nights",
    person: "person",
    people: "people",
    viewTravelProgramme: "View travel programme",
    valid: "Valid",
    whatsIncluded: "What's Included",
    whatsExcluded: "What's Excluded",
    maxParticipants: "Max {{count}} participants",
    requestReservation: "Request Reservation",
    tripLoading: "Your trip is loading...",
    detailsLoadErrorTitle: "This package could not be loaded",
    detailsLoadErrorDescription: "Please try again later or contact us.",
    backToTours: "Back to package tours",
    aboutPackage: "About this package",
    peopleQuestion: "How many people are travelling?",
    groupSizeHint: "Select your group size from the dropdown below",
    roomOptions: "Room options",
    roomOptionsDescription:
      "Choose your preferred room configuration. Prices are total for all {{count}} {{people}}.",
    total: "Total",
    travelProgramme: "Your travel programme",
    day: "Day {{day}}",
    included: "Included",
    notIncluded: "Not included",
    bookTour: "Book Tour",
  },
  home: {
    welcome: "Welcome",
    heroSubtitle:
      "You can't buy happiness, but you can buy plane tickets, which is kind of the same thing.",
    packageSubtitle:
      "Selected holiday packages. Click on an offer for the full travel programme.",
    viewAll: "View all",
    dealsEyebrow: "Handpicked getaways",
    appComingSoon: "The mobile app is coming",
    appBrand: "Satyam Holidays",
    appRelease: "Launching in 3-4 weeks",
    appSubtitle:
      "Search flights, book holidays and manage your trips from your pocket. The Satyam Holidays app brings the full booking experience with you.",
    appPhoneTag: "Flights • Holidays • Check-in",
    appStores: "Coming soon on the App Store and Google Play",
    appStore: "App Store",
    playStore: "Google Play",
    appPhoneSearch: "Where to next?",
    searchCheapestFlights: "Search Cheapest Flights",
    seatSelections: "Seat Selections",
    freeReservations: "Free Online Reservations",
    liveSchedules: "View Live Flight Schedules",
    popularDestinations: "Popular destinations",
    popularEyebrow: "Top routes",
    popularSubtitle:
      "The routes our travellers love most, with great fares all year round.",
    partnersTitle: "Trusted and accredited by",
    heroChips: {
      secure: "Secure payments",
      support: "24/7 personal support",
      iata: "IATA accredited agent",
    },
    showMore: "Show More",
    supportEyebrow: "Travel support",
    supportTitle: "Need to adjust your trip? We make it simple.",
    supportSubtitle:
      "From changes to baggage questions, our team helps you keep your travel plans clear and stress-free.",
    supportCards: {
      change: {
        label: "Flexible plans",
        title: "Change your booking with confidence",
        body: "Plans can change. We help you understand your options and guide you through the next step.",
      },
      help: {
        label: "Smart comparison",
        title: "Use the pricing table to find your best option",
        body: "Compare nearby travel dates and prices at a glance, so you can choose the fare that fits best.",
      },
      baggage: {
        label: "Smart fares",
        title: "Find better value with baggage included",
        body: "Use baggage filters while searching to compare fares that already include checked luggage.",
      },
    },
    paymentMethods: {
      eyebrow: "Flexible payments",
      title: "Pay your way, securely",
      subtitle:
        "Choose the payment option that works best for you. From cards to local methods, checkout is simple and secure.",
      securityNote: "PCI DSS Level 1 compliant payment processing.",
      klarnaSpotlight: {
        badge: "Only at Satyam Tours",
        title: "Book now, pay later with Klarna",
        body: "Reserve your trip with more flexibility and choose BNPL at checkout when available.",
        note: "Availability depends on your booking and selected payment options.",
      },
      methods: {
        klarna: {
          title: "Klarna BNPL",
          body: "Book now and pay later when this option is available at checkout.",
        },
        creditCard: {
          title: "Credit card",
          body: "Pay securely with major cards through our encrypted checkout.",
        },
        ideal: {
          title: "iDEAL",
          body: "Use a trusted Dutch payment method for quick bank checkout.",
        },
        tikkie: {
          title: "Tikkie",
          body: "Open your Tikkie link and complete payment from your phone.",
        },
        applePay: {
          title: "Apple Pay",
          body: "Check out quickly using the cards saved on your Apple device.",
        },
        sepa: {
          title: "SEPA",
          body: "Pay directly from supported European bank accounts.",
        },
        cartesBancaires: {
          title: "Cartes Bancaires",
          body: "Use a trusted French card network when it is available.",
        },
        blik: {
          title: "Blik",
          body: "Complete payment using a fast mobile banking code.",
        },
        bancontact: {
          title: "Bancontact",
          body: "Pay with a popular Belgian payment method.",
        },
        mobilePay: {
          title: "MobilePay",
          body: "Use a simple mobile wallet checkout from your phone.",
        },
        bankTransfer: {
          title: "Bank transfer",
          body: "Prefer manual payment? Bank transfer options are available too.",
        },
      },
    },
  },
  cars: {
    dropOffTime: "Drop-off time",
    pickUpTime: "Pick-up time",
  },
  banner: {
    flights: "Flights",
    hotels: "Hotels",
    comingSoon: "Coming Soon",
    quickRoutes: "Popular routes",
    quickRoutesShow: "Show",
    quickRoutesHide: "Hide",
    filters: "Filters",
    from: "From",
    to: "To",
    destination: "Destination",
    departureDate: "Departure Date",
    checkIn: "Check In",
    checkOut: "Check Out",
    trip: "Trip {{number}}",
    letsGo: "Let's go",
    addDestination: "Add Destination",
    refundableFare: "Refundable Fare",
    return: "Return",
    oneWay: "One-way",
    multiCity: "Multi-city",
    economy: "Economy",
    premiumEconomy: "Premium Economy",
    business: "Business",
    firstClass: "First Class",
    passengers: "Passengers",
    senior: "Senior",
    adults: "Adults",
    children: "Children",
    infants: "Infants",
    bags: "Bags",
    checked: "Checked",
    checkedBaggage: "Checked baggage",
    adult: "Adult",
    howManyRooms: "How many Rooms",
  },
  filters: {
    officeId: "Office ID",
    refundableFare: "Refundable Fare",
    refundFare: "Refund Fare",
    baggage: "Baggage",
    checkedBaggage: "Checked baggage",
    twoCheckedBaggage: "2x Checked baggage",
    cabinType: "Cabin Type",
    economy: "Economy",
    premiumEconomy: "Premium Economy",
    business: "Business",
    firstClass: "First Class",
    stops: "Stops",
    nonStop: "Non Stop(direct)",
    upToOneStop: "Up to 1 stop",
    upToTwoStops: "Up to 2 stop",
  },
  resultCard: {
    priceDrop: "Price drop",
    targetFlight: "Target Flight",
    linkCopied: "Link Copied!",
    copyLink: "Copy Link",
    analyze: "Analyze",
    days: "{{count}} Days",
    showDetails: "Show Details",
    shareQuote: "Share Quote",
    shareQuoteSubtitle:
      "Review the fare, then download a quote image to send to your customer.",
    shareQuoteRoute: "Itinerary",
    shareQuoteDownload: "Download quote",
    viewRules: "View Rules",
    seatsLeft: "{{count}} Seats Left",
    copyFlightLink: "Copy Flight Link",
    copyError: "There is something wrong. Please try again.",
    targetedSuccess: "The flight was targeted successfully",
    error: "There was an error",
    description: "Description",
    totalBankPrice: "Total Bank Price ({{currency}})",
    totalCashPrice: "Total Cash Price ({{currency}})",
  },
  sidebar: {
    title: "Want to fly for even less?",
    description:
      "Try the 2x checked baggage filter to find Satyam Special fares with more baggage included.",
    cta: "Try 2x checked baggage",
    defaultTitle: "Travel smarter with Satyam",
    defaultDescription:
      "Compare flexible dates, baggage options, and package deals to find the fare that fits your trip best.",
    activeBadge: "Filter active",
    activeTitle: "2x checked baggage is active",
    activeDescription:
      "You are now viewing Satyam Special fares with two checked bags included.",
    activeCta: "2x checked baggage selected",
  },
  noBaggageModal: {
    title: "No checked baggage included",
    description:
      "This fare is priced without checked luggage. To compare options that include bags, select one of the filters below.",
    sectionLabel: "Show fares with baggage",
    twoBagsDescription:
      "View Satyam Special fares with two checked bags included.",
    oneBagDescription: "View fares with at least one checked bag included.",
    continue: "Continue without baggage",
    recommended: "Recommended",
  },
  booking: {
    steps: {
      search: "Search",
      passengerDetails: "Passenger Details",
      seatMap: "Seat Map",
      overviewPayment: "Overview & Payment",
    },
    labels: {
      tripSummary: "Trip summary",
      trip: "Trip {{number}}",
      departure: "Departure",
      return: "Return",
      duration: "Duration",
      flightNo: "Flight no",
      airline: "Airline",
      aircraft: "Aircraft",
      travelersInfo: "Travelers Info",
      primaryPassenger: "Primary passenger ({{type}})",
      firstName: "First Name",
      lastName: "Last Name",
      dateOfBirth: "Date of birth",
      gender: "Gender",
      email: "Email",
      phoneNumber: "Phone Number",
      passportNumber: "Passport Number",
      passportExpirationDate: "Passport Expiration date",
      issuanceCountry: "Issuance Country",
      nationality: "Nationality",
      checkedBags: "Checked bags",
      checkedBag: "Checked bag",
      included: "Included",
      numberOfPassengers: "Number of Passengers",
      passenger: "Passenger",
      seatFor: "{{type}} seat for {{name}}",
      packageDeal: "Package deal",
      packageDealBooking:
        "Package deal booking - Package price: {{currency}}{{price}} included in total",
      total: "Total ({{currency}})",
      priceSummary: "Price summary",
      secureNote: "Secure booking — no hidden fees",
      taxesAndFees: "Taxes & fees",
      noHiddenCosts: "No hidden costs",
      secureBooking: "Secure & reliable booking",
      person: "person",
      people: "people",
      single: "Single",
      double: "Double",
      triple: "Triple",
      quad: "Quad",
      overview: "Overview",
      itinerary: "Itinerary",
      passengers: "Passengers",
      flight: "flight",
      flights: "flights",
      direct: "Direct",
      stopCount: "{{count}} stop",
      showFlightDetails: "Show details",
      hideFlightDetails: "Hide details",
      step1Eyebrow: "Step 1 · Traveler details",
      step4Eyebrow: "Step 4 · Overview & payment",
      readyToConfirm: "Ready to confirm",
      travelerCard: "Traveler {{number}}",
      personalDetails: "Personal details",
      contactDetails: "Contact details",
      travelDocuments: "Travel documents",
      scanPassport: "Scan passport",
      scanningTitle: "Scanning passport…",
      scanningHint: "Hold on, we're securely reading the details.",
      scanConfidence: "Scan quality",
      confirmations: "Confirmations",
      consentProgress: "{{count}} of 3 confirmed",
      readyToContinue: "Ready for the next step",
      travelerReady: "{{count}} travelers",
      baggage: "Baggage",
      personalItem: "Personal item",
      seating: "Seating",
      specificSeat: "specific seat",
    },
    travelerTypes: {
      ADULT: "Adult",
      CHILD: "Child",
      HELD_INFANT: "Infant",
      SENIOR: "Senior",
    },
    options: {
      male: "Male",
      female: "Female",
    },
    messages: {
      noBaggage:
        "Note: this reservation has no baggage included. To add a bag to your reservation, please call us or send an email with your reference ID.",
      uploadPassport:
        "Upload or pick a clear image of the passport to fill in traveler details.",
      travelersHint: "Enter each name exactly as it appears on the passport.",
      reviewHint: "Check every traveler and flight before you confirm the reservation.",
      confirmHint: "Your booking will be created after you place the reservation.",
      sameEmailPhone: "Use the same email and phone number",
      verifyInfo:
        "I have verified that all the information on this form is correct.",
      scannerNotice:
        "I acknowledge that if the passport image is not clearly visible, the scanner may have generated invalid data, and I may need to make adjustments if needed.",
      visaNotice:
        "I have verified that I either possess a valid visa or do not require a visa to travel to {{destination}}",
      visaDuration:
        "for the duration of {{days}} days as specified in my reservation.",
      seatMapUnavailable:
        "Seat map is currently not available from the airline. Please select a seat at the airport while checking in.",
      reservationError: "Sorry, there is something wrong! Please try again.",
      reservationLoading: "We are securing your reservation",
      reservationLoadingDescription:
        "Please keep this page open while we confirm your flight details.",
      reservationLoadingTipTitle: "Did you know?",
      reservationLoadingTip:
        "You can often fly for less by searching fares with the 2x checked baggage filter.",
      expirationMissing:
        "Departure date is missing or unavailable. Please check the flight details.",
      expirationIncomplete:
        "Expiration date fields are incomplete. Please provide all date details.",
      expirationInvalidFormat:
        "Invalid expiration date format. Please check the date.",
      travelerExpirationUnverified:
        "Traveler {{number}}: The passport expiration date could not be verified. The scanned date may be incorrect.",
      travelerExpirationWarning:
        "Traveler {{number}}: Passport expires on {{date}}, which is within 6 months of the departure date.",
    },
    validation: {
      lettersOnly: "Should contain just letters",
      expirationRequired: "Expiration Passport Date is required",
      expirationInvalid: "Expiration Passport Date is invalid!",
      invalidIssuanceCountry: "Invalid Issuance Country",
      documentsRequired: "Documents are required",
      phoneInvalid: "Phone number is invalid",
    },
    seats: {
      title: "Select your seats",
      description: "Find the most comfortable seats for your group.",
      selectOnMap: "Select a seat on the map",
      available: "Available",
      blocked: "Blocked or occupied",
      selected: "Selected",
      skip: "Skip seats and continue",
    },
    actions: {
      continue: "Continue",
      placeReservation: "Place reservation",
      days: "{{count}} Days",
      addExistingTraveler: "Add Existing Traveler",
      goBackFix: "Go Back & Fix",
      understandContinue: "I Understand, Continue",
      backToResults: "Back to results",
    },
    passportWarning: {
      title: "Passport Expiration Notice",
      description:
        "We detected a potential issue with one or more passport expiration dates. Most countries require passports to be valid for at least 6 months beyond the travel date. Proceeding with an expired or soon-to-expire passport may result in denied boarding or entry.",
      responsibility:
        "By continuing, you confirm that the traveler(s) accept full responsibility for ensuring their travel documents meet all entry requirements for their destination.",
    },
    existingTravelers: {
      title: "Your travelers",
      kicker: "Saved travelers",
      choose: "Choose a saved traveler",
      chooseHint: "Auto-fill from someone you've booked before",
      change: "Change",
      use: "Use",
      added: "Added",
      applied: "Saved traveler",
      add: "Add Existing Traveler",
      fromModule: "From Module",
      searchPlaceholder: "Search by name, email or passport",
      notFound: "Not Found",
      noResults: 'No results found for "{{query}}".',
      noMatches: "No matches found",
      noMatchesHint: 'Nothing matches "{{query}}".',
      empty: "No saved travelers yet",
      emptyHint: "Travelers you book will appear here for next time.",
      loading: "Loading your travelers…",
      unnamed: "Unnamed traveler",
      searchHint:
        "Search only works by firstname, lastname, passport-number, email, or phone-number",
      uploadPassport: "Upload your passport",
      expirationInvalid:
        "Expiration Passport Date must be at least 6 months after the departure date!",
    },
  },
  confirmation: {
    title: "Booking confirmed",
    subtitleFlight:
      "Thank you for your reservation. Your flight booking is confirmed.",
    subtitlePackage:
      "Thank you for your reservation. Your flight and package tour booking is confirmed.",
    eyebrow: "Booking complete",
    referenceId: "Reference ID",
    copy: "Copy",
    copied: "Copied!",
    copyReference: "Copy reference ID",
    packageDealBooking: "Package deal booking",
    packageIncluded:
      "This booking includes a package tour. Package price: {{currency}}{{price}} is included in the total amount.",
    roomConfiguration: "Room configuration",
    packageTourDetails: "Package tour details",
    flightDetails: "Flight Details",
    travelersDetails: "Travelers Details",
    remarks: "Remarks",
    packageTour: "Package tour",
    paymentCharge: "Payment Charge",
    remarkError:
      "Your remark was not added, please add this remark manually in Sell Connect",
    remarkSuccess: "Your remark was added successfully",
    remarkPlaceholder: "Type your remark",
    remarkLabel: "Add your remark",
    addNewRemark: "Add New Remark",
    submitRemark: "Submit Remark",
    holdNotice:
      "Your reservation has been made. Complete payment soon to keep this fare and avoid losing the current price.",
  },
  payment: {
    title: "Payment",
    completeTitle: "Complete your payment",
    lead: "Your reservation is confirmed. Choose a method below to keep this fare.",
    chooseMethod: "Choose a payment method",
    loading: "Loading payment options…",
    tikkie: "Tikkie",
    tikkieHint: "Pay instantly with Tikkie. This opens in a new tab.",
    cashHint: "Pay in cash at our office.",
    methodHint: "We will confirm this payment after it is received.",
    bankTransfers: "Bank transfer",
    bankHint: "Transfer to one of our accounts and include your reference.",
    chooseBank: "Choose a bank",
    viewDetails: "View account",
    extraCharge: "Additional fee",
    payNow: "Pay now",
    yourReference: "your reference number",
    otherMethodsTitle: "Need another method?",
    otherMethods:
      "Contact us and mention {{reference}}. We will help you pay another way.",
    contactUs: "Contact us",
    cashNextTitle: "Pay in person",
    cashNext:
      "Visit one of our offices and bring reference {{reference}}. Our team will complete the cash payment for you.",
    bankNextTitle: "Pay by bank transfer",
    bankNext:
      "Choose one of the banks below, make the transfer with reference {{reference}}, then send the payment proof via WhatsApp.",
    sendProofWhatsapp: "Send payment proof on WhatsApp",
    whatsappProofMessage:
      "Hello, I made a bank transfer for reservation {{reference}}. Here is my payment proof.",
  },
};

export default en;
